<template>
  <div class="bg-black c-white">
    <div class="p-y-6">
      <div class="container p-x-2:mo">
        <div class="m-b-1:mo">
          <div class="layout gap-2">
            <div class="layout-item is-12 is-6:t">
              <router-link
                  :to="{ name: 'about::legal::privacy' }"
                  class="FOOTER-LINK"
                  selenium="privacy-policy-link">
                Privacy Policy
              </router-link>
            </div>
            <div class="layout-item is-12 is-6:t">
              <div class="text-right:t">
                <router-link
                    :to="{ name: 'about::legal::tos' }"
                    class="FOOTER-LINK"
                    selenium="tems-of-service-link">
                  Terms of Service
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="layout gap-2">
          <div class="layout-item is-12 is-4:t" selenium="powered-by-text">
            Powered by The Home Depot
          </div>
          <div class="layout-item is-12 is-4:t text-center:t">
            <!-- eslint-disable-next-line max-len -->
            Questions? Call us at
            <a
                href="tel:18557232266"
                class="LINK"
                selenium="call-us-link">1-855-723-2266</a> or email us at
            <a
                href="mailto:support@proreferral.com"
                class="LINK"
                selenium="email-us-link">support@proreferral.com</a>
            <div class="m-t-2" selenium="footer-screen-reader">
              For screen reader problems with this website, please call
              <a
                  href="tel:18557232266"
                  class="LINK">1-855-723-2266</a>
            </div>
          </div>
          <div class="layout-item is-12 is-4:t">
            <div class="text-right:t" selenium="copyright-text">
              © Pro Referral | All Rights Reserved
              <div class="d-flex fd-column m-t-2">
                <a
                    class="FOOTER-LINK"
                    href="https://www.homedepot.com/c/California_Privacy_Rights"
                    target="_blank"
                    rel="noopener noreferrer"
                    selenium="footer-california-privacy">California Privacy Rights & Report</a>
                <a
                    class="FOOTER-LINK"
                    href="https://www.homedepot.com/c/Exercise_My_Privacy_Rights"
                    target="_blank"
                    rel="noopener noreferrer"
                    selenium="footer-privacy-rights">
                  Do Not Sell or Share My Personal Information</a>
                <a
                    class="FOOTER-LINK"
                    href="https://www.homedepot.com/privacy/Exercise-My-Privacy-Rights"
                    target="_blank"
                    rel="noopener noreferrer"
                >Limit the Use of My Sensitive Personal Information</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-footer-lower',
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";
.FOOTER-LINK {
  color: #EDEDED;
}
.LINK {
  color: #0069D9;
}
</style>
